import { FormControl, Grid } from '@mui/material';
import PaginationBasic from 'components/Pagination/Pagination';
import usePagination from 'hooks/usePagination';
import { Pagination } from 'types/api';
import { Wallet } from 'types/wallet';
import BackgroundCard from 'ui-component/cards/BackgroundCard';
import CoinList from './CoinList';

const CoinListSection = ({ data, paging, isLoading }: { data: Wallet[]; paging: Pagination | null; isLoading: boolean }) => {
    const { currentPage, onChangePage } = usePagination();
    return (
        <BackgroundCard>
            <FormControl fullWidth>
                <Grid container>
                    {/* <Grid item xs={12}>
                        <Grid container justifyContent="space-between" alignItems="center">
                            <Grid item>
                                <FormattedMessage id="filter-by-currency" />
                            </Grid>
                            <Grid item>
                                <FormControlLabel control={<Checkbox />} label={<FormattedMessage id="hide-zero-balances" />} />
                            </Grid>
                        </Grid>
                    </Grid> */}
                    <Grid item xs={12}>
                        <CoinList data={data} isLoading={isLoading} />
                    </Grid>
                    {paging ? (
                        <Grid item xs={12}>
                            <PaginationBasic
                                currentPage={currentPage}
                                total={paging?.totalPages}
                                callBack={(pageNew: number) => onChangePage(pageNew + 1)}
                                disabled={isLoading}
                            />
                        </Grid>
                    ) : null}
                </Grid>
            </FormControl>
        </BackgroundCard>
    );
};

export default CoinListSection;
